import { Box, Breadcrumbs, Button, Grid, Modal, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import { ADD_CATEGORY, CHANGE_STATUS_CATEGORY, GET_CATEGORY, GLOBAL } from "../../constant/endpoint";
import moment from "moment";
import { isEmpty } from "lodash";
import Swal from "sweetalert2";
import { useStyles } from "../../constant/constant";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Paper from '@mui/material/Paper';

export const Category = () => {
    const [open, setOpen] = useState(false)
    const [imageofQustion, setImageofQustion] = React.useState(undefined);
    const [category_name, setCategorName] = React.useState(undefined);
    const [category_desc, setCategorDesc] = React.useState(undefined);
    const [predic_start_time, setPredicStartTime] = React.useState(undefined);
    const [categoryList, setCategoryList] = useState([])
    const [categoryDetails, setCategoryDetails] = useState({})
    const [isEdit, setIsEdit] = useState(false)
    const classes = useStyles();
    const [value, setValue] = React.useState('1');
    const [sort, setSort] = React.useState({});

    useEffect(() => {
        getCategoryList()
    }, [])

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const getCategoryList = async () => {
        const result = await axios.get(GET_CATEGORY)
        if (result?.data.status === "success") {
            setCategoryList(result?.data.data)
        }
    }
    const imageFile = (e) => {
        const file = e.target.files[0]
        setImageofQustion(file)
    }
    const handleClose = () => setOpen(false);
    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={''} >
            <h4>Category</h4>
        </Link>, <h5>List</h5>
    ];
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '55%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        padding: '0px 30px',
        overflow: "auto",
        paddingBottom: "20px"
    };
    const addCategory = () => {
        setCategoryDetails({
            category_name: '',
            category_desc: '',
            predic_start_time: moment().format('YYYY-MM-DD HH:mm'),
        })
        setOpen(true)
    }
    const getSweetAlert = (type, topic) => {
        Swal.fire({
            position: 'top-end',
            icon: type,
            title: topic,
            showConfirmButton: false,
            timer: 3000
        })
    }
    const validation = () => {
        let status = true;
        if (isEmpty(categoryDetails.category_name)) {
            status = false
            getSweetAlert('error', "Category Name not be blank")
        } else if (isEmpty(categoryDetails.predic_start_time)) {
            status = false
            getSweetAlert('error', "Category Date not be blank")
        } else if (isEmpty(categoryDetails.category_desc)) {
            status = false
            getSweetAlert('error', "Category Description not be blank")
        } else if (categoryDetails.category_name.length > 20) {
            status = false
            getSweetAlert('error', "Category name not more than 20 character")
        } else if (categoryDetails.category_name.length > 100) {
            status = false
            getSweetAlert('error', "Category Description not more than 100 character")
        }
        return status
    }
    const submit = async () => {
        if (validation()) {
            const formData = new FormData()
            let data = {
                match_id: categoryDetails.match_id,
                category_name: category_name,
                category_desc: category_desc,
                predic_start_time: moment(predic_start_time).utc().format(),
            }
            formData.append('image', imageofQustion);
            formData.append('data', JSON.stringify(data));

            if (isEdit) {
                const response = await axios.patch(ADD_CATEGORY, formData)
                if (response?.data.status === "success") {
                    setOpen(false)
                    getCategoryList()
                    window.location.reload(false);
                    getSweetAlert('success', "Category Edited Succesfully")
                }
            } else {
                const response = await axios.post(ADD_CATEGORY, formData)
                if (response?.data.status === "success") {
                    setOpen(false)
                    getCategoryList()
                    getSweetAlert('success', "Category Added Succesfully")
                }
            }
        }

    }
    const listStatusUpdate = async (data, match_id) => {
        const dataSt = {
            status: data,
            match_id: match_id
        }
        await axios.post(CHANGE_STATUS_CATEGORY, dataSt)
        getCategoryList()
    }
    const editHandle = (data) => {
        setIsEdit(true)
        setCategoryDetails({ category_name: '', category_desc: '', predic_start_time: moment().format('YYYY-MM-DD HH:mm') })
        setOpen(true)
        setImageofQustion('')
        setCategoryDetails(data)
    }
    const moveHandle = async (data) => {
        const formData = new FormData()
        let newData = {
            match_id: data.match_id,
            movefinish: true
        }
        if (data.status) {
            getSweetAlert('error', "Please InActive category before moving in finish")
        } else {
            formData.append('data', JSON.stringify(newData));
            const response = await axios.patch(ADD_CATEGORY, formData)
            if (response?.data.status === "success") {
                setOpen(false)
                getCategoryList()
                window.location.reload(false);
                getSweetAlert('success', "Move to Finish")
            }
        }
    }
    const handleName = (e) => {
        setCategorName(categoryDetails.category_name = e.target.value)
    }
    const handleDisc = (e) => {
        setCategorDesc(categoryDetails.category_desc = e.target.value)
    }
    const handleDate = (e) => {
        setPredicStartTime(categoryDetails.predic_start_time = e.target.value)
    }
    const globalFiles = async (e, data) => {
        var formData = new FormData()
        formData.append('files', e.target.files[0]);
        formData.append('match_id', data.match_id);
        const response = await axios.post(`${GLOBAL.replace(':match_id', data.match_id)}?skiller=true`, formData)
        if (response.data.status === 'success') {
            Swal.fire('Global Image Upload Successfully')
            await getCategoryList()
        } else {
            alert('something went wrong')
        }
    }
    const handleSortingInput = (e, id) => {
        if (e.target.value) {
            setSort(prevValue => ({ ...prevValue, [id]: { sort_number: e.target.value } }))
        }

    }
    const handleShorting = async (data) => {
        let data1 = {
            ...data
        }
        data1.sort_number = sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number
        delete data1.status
        const formData = new FormData()
        // formData.append('image', imageofQustion);
        formData.append('data', JSON.stringify(data1));

        let result = await axios.patch(ADD_CATEGORY, formData)

        if (result?.data?.status === 'success') {
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Sorting add Successfully',
                showConfirmButton: false,
                timer: 1500
            })
        }
        getCategoryList()
    }
    return (
        <div className="homeCard">
            <div className='subHomeCard'>
                <Breadcrumbs
                    separator={<MdNavigateNext fontSize="small" />}
                    aria-label="breadcrumb"
                >

                    {breadcrumbs}
                </Breadcrumbs>
                <Button variant={'contained'} color={'primary'} style={{ float: "right" }} onClick={addCategory}>Add Category</Button>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                    <TabContext value={value}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleChange} aria-label="lab API tabs example">
                                <Tab label="Category" value="1" />
                                <Tab label="Finish" value="2" />
                            </TabList>
                        </Box>
                        <TabPanel style={{ padding: "0px" }} value="1">
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableCell>Image</TableCell>
                                        <TableCell>Category</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Sorting</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Start time</TableCell>
                                        <TableCell>Expires In</TableCell>
                                        <TableCell>Move To finish</TableCell>
                                        <TableCell>Questions</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            categoryList.filter(x => !x.movefinish)?.map((data, index) =>
                                                <TableRow>
                                                    <TableCell>
                                                        <img src={data?.category_image} style={{ width: '85px' }} alt='' />
                                                        <input
                                                            style={{ width: '90px' }}
                                                            accept="image/*"
                                                            id="contained-button-file"
                                                            // multiple
                                                            type="file"
                                                            onChange={(e) => globalFiles(e, data)}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{data.category_name}</TableCell>
                                                    <TableCell>{data.category_desc}</TableCell>
                                                    <TableCell >
                                                            <Grid container style={{ display: "flex", background: '#fff' }}>
                                                                <TextField type='number' width={'50px'} size='small' id="outlined-basic" label="Sorting" variant="outlined" style={{ fontStyle: "8px" }} autocomplete="off"  onChange={(e) => handleSortingInput(e, data._id)} value={sort[data._id]?.sort_number ? sort[data._id]?.sort_number : data.sort_number} />
                                                                <Button variant='contained' color={'warning'} style={{ fontSize: "11px", width: "60px", padding: '1px' }}onClick={() => handleShorting(data)} >Update</Button>
                                                            </Grid>
                                                        </TableCell>
                                                    <TableCell>
                                                        <Button variant='contained' color={data.status ? 'success' : 'error'} size="small" onClick={() => listStatusUpdate(data.status ? false : true, data.match_id)}> {data.status ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    <TableCell>{moment(data.predic_start_time).format('YYYY-MM-DD')}</TableCell>
                                                    <TableCell>{moment(data.updatedAt).add(30,"days").fromNow()}</TableCell>
                                                    <TableCell textAlign="center">
                                                        <Button variant={'contained'} color={'warning'} size="small" onClick={() => moveHandle(data)}>Move</Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Link style={{ color: "blue", fontWeight: "600" }} variant={'contained'} size='small' color={'warning'} to={`/matchlist/trading/${data.match_id}/${data.series_id}/${data.sport}`}>Questions List</Link>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button variant={'contained'} color={'primary'} style={{ float: "right" }} onClick={() => editHandle(data)}>Edit</Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel style={{ padding: "0px" }} value="2">
                            <TableContainer component={Paper} style={{ margin: "30px 0px" }}>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableCell>Id</TableCell>
                                        <TableCell>Category</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Start time</TableCell>
                                        <TableCell>Move To finish</TableCell>
                                        <TableCell>Questions</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            categoryList.filter(x => x.movefinish)?.map((data, index) =>
                                                <TableRow>
                                                    <TableCell>{index + 1}</TableCell>
                                                    <TableCell>{data.category_name}</TableCell>
                                                    <TableCell>{data.category_desc}</TableCell>
                                                    <TableCell>
                                                        <Button variant='contained' color={data.status ? 'success' : 'error'} size="small" onClick={() => listStatusUpdate(data.status ? false : true, data.match_id)} disabled={true}> {data.status ? 'Active' : 'InActive'}</Button>
                                                    </TableCell>
                                                    <TableCell>{moment(data.predic_start_time).format('YYYY-MM-DD')}</TableCell>
                                                    <TableCell>
                                                        <Button variant={'contained'} color={'primary'} style={{ float: "right" }} onClick={() => moveHandle(data)} disabled={true}>Move</Button>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Link style={{ color: "blue", fontWeight: "600" }} variant={'contained'} size='small' color={'warning'} to={`/matchlist/trading/${data.match_id}/${data.series_id}/${data.sport}`}>Questions List</Link>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button variant={'contained'} color={'primary'} style={{ float: "right" }} onClick={() => editHandle(data)} disabled={true}>Edit</Button>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                    </TabContext>
                </Box>
                <Box>
                </Box>
            </div>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                onBackdropClick={() => setOpen(true)}
            >
                <Box sx={style} spacing={0.5} direction="row" useFlexGap flexWrap="wrap">
                    <h3>Add Category</h3>
                    <Grid xs={12} item style={{ marginTop: "20px" }}>
                        <label>Category Name</label><br></br>
                        <TextField style={{ width: "100%" }} id="outlined-basic" type='text' size={'small'} variant="outlined" name={'category_name'} value={categoryDetails.category_name} onChange={handleName} required />
                    </Grid>
                    <Grid xs={12} style={{ marginTop: "20px" }} container>
                        <label>Category Description</label><br></br>
                        <TextField style={{ width: "100%" }} id="outlined-basic" type='text' size={'small'} variant="outlined" name={'category_desc'} value={categoryDetails.category_desc} onChange={handleDisc} required />
                    </Grid>
                    <Grid xs={12} item style={{ marginTop: "20px" }}>
                        <label>Start Date and Time</label><br></br>
                        <TextField style={{ width: "100%", marginTop: "10px" }} type='datetime-local' id="outlined-basic" size={'small'} variant="outlined" name={'predic_start_time'} value={moment(categoryDetails.predic_start_time).format('YYYY-MM-DD HH:mm')} onChange={handleDate} />
                    </Grid>
                    <Grid xs={12} container>
                        <Grid xs={6} style={{ marginTop: "20px" }}>
                            <label>Category image</label><br></br>
                            <input
                                accept="image/*"
                                id="contained-button-file"
                                multiple
                                type="file"
                                onChange={imageFile}
                            />
                        </Grid>
                    </Grid>
                    <Grid xs={12} container style={{ marginTop: "40px" }}>
                        <Grid xs={9} mt={2}>
                            <Button color='error' onClick={handleClose} variant="contained">Cancel</Button>
                        </Grid>
                        <Grid xs={3} mt={2} textAlign={'right'}>
                            <Button onClick={submit} variant="contained">Submit</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    )
}